import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "clear-multi",
  standalone: true,
  imports: [TranslateModule, CommonModule],
  template: `
    <button
      role="button"
      class="clear-muilti-cell"
      [attr.aria-label]="'translate.general.clearChoice' | translate"
    >
      <i class="fs-small fas fa-times"></i>
    </button>
  `,
})
export class ClearMultiComponent {
  killTooltip: boolean = false;
  constructor() {}
}
